import { appConst } from "../AppConst";
import { IBaseResponse } from "../model/response/IBaseResponse";
import { axiosClient } from "./axiosClient";

const apiGuestClient = {
    get: async (path: string): Promise<IBaseResponse> => {
        const url = `${appConst.baseApiURL}/${path}`
        try {
            
            const config = {
                headers: {
                    language: localStorage.getItem("language"),
                }
            }
            const res = await axiosClient.get<any,IBaseResponse>(url, config);
            return res;
        } catch (error: any) {
            return {
                code: error.response.data.code,
                is_success: false,
                message: error.response.data.message || "Có lỗi"
            };

        }
    }
    ,
    post: async (path: string, data?: any, domain?: string): Promise<IBaseResponse> => {
        const url = `${domain ? domain : appConst.baseApiURL}/${path}`

        try {
            const config = {
                headers: {
                    language: localStorage.getItem("language"),
                }
            }
            const res = await axiosClient.post<any, IBaseResponse>(url, data, config);
            return res;
        } catch (error: any) {
            return {
                code: error.response.data.code,
                is_success: false,
                message: error.response.data.message || "Có lỗi"
            };

        }
    },
    put: async (path: string, data?: any): Promise<IBaseResponse> => {
        const url = `${appConst.baseApiURL}/${path}`
        try {
            const config = {

                headers: {
                    language: localStorage.getItem("language"),
                }
            }
            const res = await axiosClient.put<any, IBaseResponse>(url, data, config);
            return res;
        } catch (error: any) {
            return {
                code: error.response.data.code,
                is_success: false,
                message: error.response.data.message || "Có lỗi"
            };
        }
    },
    delete: async (path: string): Promise<IBaseResponse> => {
        const url = `${appConst.baseApiURL}/${path}`
        try {
            
            const config = {
                headers: {
                    language: localStorage.getItem("language"),
                }
            }
            const res = await axiosClient.delete<any, IBaseResponse>(url, config);
            return res;
        } catch (error: any) {
            return {
                code: error.response.data.code,
                is_success: false,
                message: error.response.data.message || "Có lỗi"
            };

        }
    },
    
}
export { apiGuestClient };